import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dailyData" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import { computed, onBeforeMount } from "vue";
import { useUserDaysStore } from "@/store/userDays";
import { useCalendarStore } from "@/store/calendar";
import { useLangStore } from "@/store/lang";
import { useUserInfo } from "@/store/userInfo";
import { useCalculatorStore } from "@/store/calculator";
import { nightAllowance } from "@/utils/calculator";

import { presence, vacation, overhours } from "@/config/dayInfoFields";
import { Group, Overhours, Presence, Vacation } from "@/types/dailyInfo";


export default /*#__PURE__*/_defineComponent({
  __name: 'DaySummary',
  props: {
  date: {
    type: Object,
    required: true,
  },
},
  emits: ["editMode", "closeDaySummary"],
  setup(__props, { emit: emits }) {

const props = __props;

const userDays = useUserDaysStore();
const userInfo = useUserInfo();
const calendarStore = useCalendarStore();
const langStore = useLangStore();
const calculatorStore = useCalculatorStore();

const messages = computed(() => {
  return langStore.messages.dailyData;
});





const dayInfo = computed(() => {
  const info = userDays.dailyInfo.filter((el) => {
    return el.day === props.date.day.value;
  });
  return info[0];
});

const dayDescription = computed(() => {
  const compared = [...presence, ...vacation, ...overhours];
  const infoField = compared.filter((item) => {
    return item.value === dayInfo.value.value;
  });
  return infoField[0].description;
});

const dayPayment = computed(() => {
  if (userInfo.userInfo.salaryAmount.value === null)
    return messages.value.functions;

  let payment =
    Number(userInfo.userInfo.salaryAmount.value) /
    calculatorStore.getDaysToWork(
      props.date.year.value,
      props.date.month.value
    );

  if (dayInfo.value.value === Presence.notfullday)
    payment = (payment / 8) * dayInfo.value.hours;
  if (dayInfo.value.value === Presence.nightfullday) {
    payment =
      payment +
      nightAllowance(props.date.year.value, props.date.month.value) * 8;
  }

  if (dayInfo.value.value === Overhours.fifty)
    payment = payment + (payment / 8) * dayInfo.value.hours * 1.5;

  if (dayInfo.value.value === Overhours.hundert)
    payment = payment + (payment / 8) * dayInfo.value.hours * 2;

  if (dayInfo.value.value === Presence.hundertday) payment = payment * 2;

  if (dayInfo.value.value === Vacation.nonpaid) payment = 0;

  return payment.toFixed(2);
});

const deleteDayInfo = () => {
  userDays.deleteDayInfo({
    year: props.date.year.value,
    month: props.date.month.value,
    day: props.date.day.value,
  });
  emits("closeDaySummary");
};

const editMode = () => {
  emits("editMode");
  emits("closeDaySummary");
};

const hoursAtWork = computed(() => {
  let hours = 0;
  if (
    (dayInfo.value.group === Group.Overhours &&
      dayInfo.value.value === Overhours.fifty) ||
    dayInfo.value.value === Presence.atwork ||
    dayInfo.value.value === Presence.hundertday ||
    dayInfo.value.value === Presence.nightfullday
  )
    hours += 8;
  if (
    dayInfo.value.value === Presence.notfullday ||
    dayInfo.value.value === Presence.nightnotfullday
  )
    hours += dayInfo.value.hours;
  return hours;
});

const isHoliday = computed(() => {
  const holiday: { [k: string]: { day: number; name: string } }[] = [];
  calendarStore.holidays.forEach((obj) => {
    if (obj.month === props.date.month.value)
      holiday.push(
        Object.fromEntries(
          Object.entries(obj.days).filter(([, val]) => {
            return val.day === props.date.day.value;
          })
        )
      );
  });

  if (holiday[0] && holiday[0][1]) return holiday[0][1].name;
  return false;
});

const overHours = computed(() => {
  let hours = 0;
  if (dayInfo.value.value === Overhours.fifty) hours += dayInfo.value.hours;
  if (dayInfo.value.value === Overhours.hundert) hours += dayInfo.value.hours;
  return hours;
});

const showHoursAtWorkField = computed(() => {
  return dayInfo.value.group != Group.Vacation;
});
const showOverhoursField = computed(() => {
  return dayInfo.value.group === Group.Overhours;
});

onBeforeMount(() => {
  calculatorStore.getMinimumWage(2023, 1, 1);
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_dialog = _resolveComponent("base-dialog")!

  return (_openBlock(), _createBlock(_component_base_dialog, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_unref(messages).daySummaryText) + " " + _toDisplayString(__props.date.day) + "." + _toDisplayString(__props.date.month) + "." + _toDisplayString(__props.date.year) + ": ", 1),
        (_unref(isHoliday))
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_unref(isHoliday)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("h3", null, _toDisplayString(_unref(messages).dayActivityText), 1),
        _createElementVNode("h4", null, _toDisplayString(_unref(dayDescription)), 1),
        (_unref(showHoursAtWorkField))
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(messages).hoursAtWorkText) + " " + _toDisplayString(_unref(hoursAtWork)), 1))
          : _createCommentVNode("", true),
        (_unref(showOverhoursField))
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(messages).overhoursText) + " " + _toDisplayString(_unref(overHours)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, _toDisplayString(_unref(messages).bruttoText) + " " + _toDisplayString(_unref(dayPayment)), 1),
        _createVNode(_component_base_button, { onClick: editMode }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(messages).changeText), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_base_button, {
          mode: "flat",
          onClick: deleteDayInfo
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(messages).deleteText), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})